module.exports = __webpack_public_path__ + "img/File-unknow-file.489c04d6.svg";